import React from "react";

import { EmptyState, NotificationSnackbar, Pagination, SectionCard } from "shared/ui";

import { PaymentsHistoryContext } from "features/PaymentsHistory/context";
import { usePaymentsHistoryState } from "features/PaymentsHistory/hooks/usePaymentsHistoryState";
import { CancelInvoiceDialog } from "features/PaymentsHistory/components/CancelInvoiceDialog";
import { OrdersTable } from "features/PaymentsHistory/components/OrdersTable";

import { Container, Placeholder } from "./styles";

export const PaymentsHistory = () => {
    const state = usePaymentsHistoryState();

    if (state.loading) {
        return <Placeholder>Загрузка истории оплат…</Placeholder>;
    }

    if (state.error) {
        return <Placeholder>Не удалось загрузить историю оплат</Placeholder>;
    }

    return (
        <PaymentsHistoryContext.Provider value={state}>
            <Container>
                <SectionCard title="История оплат">
                    {state.total === 0 ? (
                        <EmptyState
                            title="Оплат пока не было"
                            description="Здесь появятся оплаты тарифа: чеки по картам, счета и акты по безналичным."
                        />
                    ) : (
                        <>
                            <OrdersTable />
                            <Pagination
                                page={state.page}
                                pageSize={state.pageSize}
                                total={state.total}
                                onChange={state.goToPage}
                            />
                        </>
                    )}
                </SectionCard>

                <CancelInvoiceDialog />

                <NotificationSnackbar {...state.notify.snackbarProps} />
            </Container>
        </PaymentsHistoryContext.Provider>
    );
};
